import Vue from 'vue'
import Router from 'vue-router'
import authService from '@/api/authService'

const Login = () => import(/* webpackChunkName: "Login" */'@/views/login/Login.vue')
const Map = () => import(/* webpackChunkName: "Map" */'@/views/map/Map.vue')
const ShopsList = () => import(/* webpackChunkName: "ShopsList" */'@/views/shops-list/ShopsList.vue')
const ShopDetail = () => import(/* webpackChunkName: "ShopDetail" */'@/views/shop-detail/ShopDetail.vue')
const ShopAnalysis = () => import(/* webpackChunkName: "ShopAnalysis" */'@/views/shop-analysis/ShopAnalysis.vue')
const WidgetsDescriptions = () => import(/* webpackChunkName: "WidgetsDescriptions" */'@/components/widgets-descriptions/WidgetsDescriptions.vue')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { skipAuth: true }
    },
    {
      path: '/',
      name: 'map',
      component: Map,
      meta: { noFooter: true, noScroll: true },
      children: [
        {
          path: '/',
          name: 'shops-list',
          component: ShopsList
        },
        {
          path: '/detail',
          name: 'shop-info',
          component: ShopDetail,
          children: [
            {
              path: '/detail/:id',
              name: 'shop-detail',
              component: WidgetsDescriptions
            },
            {
              path: '/detail/:id/:type',
              name: 'shop-analysis',
              component: ShopAnalysis
            }
          ]
        }
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  if (!to.meta.skipAuth && !authService.isLoggedIn()) {
    next({ name: 'login', query: { next: to.fullPath } })
  } else {
    next()
  }
})

export default router
